<template>
    <div>
      <v-card class="pa-5">
        <v-card-text>
          <v-card-title>
            <h4>{{$t('reports.incidentsUnitType')}}</h4>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="filterData()" v-on="on" v-bind="attrs" depressed class="float-right mr-2" color="primary">
                  <v-icon small>fas fa-search</v-icon>
                </v-btn>
              </template>
              <span>{{$t('general.search')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="resetFilter" v-on="on" v-bind="attrs" depressed class="float-right mr-2" color="primary">
                  <v-icon small>fa-solid fa-eraser</v-icon>
                </v-btn>
              </template>
              <span>{{$t('general.resetFilter')}}</span>
            </v-tooltip>

            <v-btn v-if="report5.length > 0" @click="downloadGeneral" :loading="loadingButtonGeneral" color="primary">
            {{ $t('reports.downloadReport') }}
            <v-icon small class="ml-2">fas fa-cloud-download-alt</v-icon>
            </v-btn>

          </v-card-title>
          <v-card-text class="pt-4">
            <v-form v-model="valid" lazy-validation ref="form">
              <v-row dense>
                <v-col cols="3">
                  <v-text-field
                    v-model="filter.plateNum"
                    :label="$t('monitoring.plaque')"
                    :rules="rules.textNoSpecialCharsFilters"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="filter.numberEco"
                    :label="$t('general.noEco')"
                    :rules="rules.textNoSpecialChars"
                    dense
                    outlined
                  />
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    clearable
                    outlined
                    dense
                    :items="unitTypes"
                    item-text="alias"
                    item-value="id" v-model="filter.unit_type_id" :label="$t('monitoring.unit_type')"
                  />
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    clearable
                    outlined
                    dense
                    :items="sitesList"
                    item-text="text"
                    item-value="name"
                    v-model="filter.property"
                    :label="$t('monitoring.property')"
                  />
                </v-col>
                <v-col v-if="filter.dateRange" cols="3">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.date_start"
                      :label="$t('general.startDate')"
                      outlined
                      dense
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    no-title
                    color="primary"
                    v-model="filter.date_start"
                    @input="handleDateStartSelection"
                    :allowed-dates="allowedStartDates"
                    :day-style="getDayStyle"
                  />
                  </v-menu>
                </v-col>
                <v-col v-if="filter.dateRange" cols="3">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filter.date_end"
                        :label="$t('general.endDate')"
                        outlined
                        dense
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      no-title
                      color="primary"
                      v-model="filter.date_end"
                      @input="menu2 = false"
                      :allowed-dates="allowedEndDates"
                      :day-style="getDayStyle"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="2">
                  <v-checkbox v-model="filter.dateRange" :label="$t('general.dateRange')" hide-details class="mt-0" color="primary"/>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-overlay absolute opacity="0" :value="loadingTableInspection"/>
          <v-data-table
            :loading="loadingTableInspection"
            :loading-text="$t('general.loading')"
            :headers="headers"
            :items="report5"
            :single-expand="false"
            :server-items-length="optionsDataTable.totalItems"
            :options.sync="optionsDataTable"
            :footer-props="{ 'items-per-page-options': [15, 50, 70, 100] }"
            @update:page="get()"
            @update:items-per-page="get()"
            @update:sort-by="get()"
            @update:sort-desc="get()"
            item-key="id"
            show-expand
          >
            <template v-slot:item.plates:plate_number="{ item }">
              {{ item.plates && item.plates.length > 0 ? item.plates[0].plate_number : 'N/A' }}
            </template>
            <template v-slot:item.unit_number="{ item }">
              {{ item.unit_number ? item.unit_number : 'N/A' }}
            </template>
            <template v-slot:item.unit_types:name="{ item }">
              {{ item.unitTypes ? item.unitTypes.alias : 'N/A' }}
            </template>
            <template v-slot:item.count_inspection_damage="{ item }">
              {{ item.count_inspection_damage ? item.count_inspection_damage : 'N/A' }}
            </template>
            <template v-slot:item.total_damages="{ item }">
              {{ (item.count_damange_hard || 0) + (item.count_damange_moderate || 0) + (item.count_damange_soft || 0) }}
            </template>
            <template v-slot:item.damage_per_day="{ item }">
              {{ item.damage_per_day ? item.damage_per_day : 'N/A' }}
            </template>
            <template v-slot:item.damage_ratio="{ item }">
              {{ item.damage_ratio ? item.damage_ratio : 'N/A' }}
            </template>
            <!-- SE REMOVIÓ POR CAMBIO EN REQUERIMIENTOS -->
            <!-- <template v-slot:item.sites:name="{ item }">
            {{ item.sites ? item.sites.name : {item} }}
            </template> -->
            <template v-slot:item.owner="{ item }">
              <span>
                {{ item.owner ? translateProperty(item.owner) : 'N/A' }}
              </span>
            </template>
            <template v-slot:item.owner_name="{ item }">
              {{ item.owner_name ? item.owner_name : 'N/A' }}
            </template>
            <template v-slot:item.count_inspection="{ item }">
              {{ item.count_inspection ? item.count_inspection : 'N/A' }}
            </template>
            <template v-slot:item.reported_damages="{ item }">
              <div>
                <span style="color: red;">({{ item.count_damange_hard }}) {{ $t('inspections.high') }}</span>
                <br>
                <span style="color: orange;">({{ item.count_damange_moderate }}) {{ $t('inspections.moderate') }}</span>
                <br>
                <span style="color: green;">({{ item.count_damange_soft }}) {{ $t('inspections.slight') }}</span>
              </div>
            </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="py-3">
              <h4 class="text-center">{{$t('inspections.damageInspections')}}</h4>
              <v-data-table :headers="subHeaders" :items="item.inspections_damage" item-key="id">
                <template v-slot:item.consecutive_number="{ item }">
                  {{ item.consecutive_number || 'N/A' }}
                </template>
                <template v-slot:item.created_at="{ item }">
                  {{ item.created_at || 'N/A' }}
                </template>
                <template v-slot:item.name="{ item }">
                  {{ item.name || 'N/A' }}
                </template>
                <template v-slot:item.duration="{ item }">
                  {{ item.duration || 'N/A' }}
                </template>
                <template v-slot:item.user:name="{ item }">
                  {{ item.user.name || 'N/A' }}
                </template>
                <template v-slot:item.current_operator="{ item }">
                  {{ item.operator[0].name || 'N/A' }}
                </template>
                <template v-slot:item.site:name="{ item }">
                  {{ item.site.name || 'N/A' }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon class="mr-4" small @click="viewItem(item.id)" v-on="on">far fa-eye</v-icon>
                    </template>
                    <span>{{$t('general.view')}}</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </td>
          </template>
            <!-- <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="py-3">
                <h3 class="pb-1">{{item.name}}</h3>
                <h4>{{ $t('general.plates')}}:&nbsp;</h4>
                <ul v-if="item.truck !== null">
                  <li v-for="plate in item.truck.plates" :key="plate.id">
                    {{plate.plate_number}}
                  </li>
                </ul>
                <ul v-if="item.truck == null && item.container !== null">
                  <li v-for="plate in item.container.plates" :key="plate.id">
                    {{plate.plate_number}}
                  </li>
                </ul>
              </td>
            </template> -->
            <!-- <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon class="mr-4" small @click="viewItem(item.id)" v-on="on">far fa-eye</v-icon>
                </template>
                <span>{{$t('general.view')}}</span>
              </v-tooltip>
            </template> -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    :loading="loadingButton[item.id]"
                    @click="download(item)"
                    color="primary"
                    v-on="on"
                    class="mr-4"
                  >
                    <v-icon small>fas fa-cloud-download-alt</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('reports.downloadReport')}}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-dialog
        max-width="500px"
        persistent
        v-model="filterModal">
        <v-card>
          <v-card-title>
            <span class="primary--text">{{$t('reports.filter')}}</span>
          </v-card-title>
          
        </v-card>
      </v-dialog>
    </div>
  </template>
  
<script>
  export default {
    data () {
      return {
        filterModal: false,
        valid: true,
        loadingTableInspection: false,
        loadingButton: false,
        loadingButtonGeneral: false,
        showFilterMessage: true,
        firstLoad: true,
        menu: false,
        menu2: false,
        link: '',
        options: {
          itemsPerPage: 15,
          page: 1,
          total: 0
        },
        optionsDataTable: {
          itemsPerPage: 15,
          page: 1,
          total: 0
        },
        filter: {
          plateNum: '',
          numberEco: '',
          unit_type_id: null,
          property: '',
          dateRange: true,
          date_start: this.returnStartDate(),
          date_end: this.returnEndDate()
        },
        report5: [],
        sites: [],
        unitTypes: []
      }
    },
    watch: {
      sites (val) {
        if (val.length > 0) this.options.itemsPerPage = 15
      },
      'filter.dateRange' (val) {
        if (!val) {
          this.filter.date_start = null
          this.filter.date_end = null
        } else {
          this.filter.date_start = this.returnStartDate()
          this.filter.date_end = this.returnEndDate()
        }
      }
    },
    computed: {
      headers() {
        return [
          {
            text: this.$t('monitoring.plaque'),
            align: 'center',
            value: 'plates:plate_number'
          },
          {
            text: this.$t('general.noEco'),
            align: 'center',
            value: 'unit_number'
          },
          {
            text: this.$t('general.unitType'),
            align: 'center',
            value: 'unit_types:name'
          },
          // SE REMOVIÓ POR CAMBIO EN REQUERIMIENTOS
          // {
          //   text: this.$t('general.yard'),
          //   align: 'center',
          //   value: 'sites:name'
          // },
          {
            text: this.$t('general.property'),
            align: 'center',
            value: 'owner'
          },
          {
            text: this.$t('general.owne'),
            align: 'center',
            value: 'owner_name'
          },
          {
            text: this.$t('inspections.count'),
            align: 'center',
            value: 'count_inspection'
          },
          {
            text: this.$t('general.reportedDamage'),
            align: 'left',
            value: 'reported_damages',
            sortable: false
          },
          {
            text: this.$t('inspections.damageInspections'),
            align: 'left',
            value: 'count_inspection_damage',
          },
          {
            text: this.$t('general.totalDamages'),
            align: 'left',
            value: 'total_damages',
          },
          {
            text: this.$t('general.frequencyOfDamage'),
            align: 'left',
            value: 'damage_ratio',
          },
          {
            text: this.$t('general.damagesPerDay'),
            align: 'left',
            value: 'damage_per_day',
          },
          {
            text: this.$t('general.actions'),
            align: 'center',
            value: 'actions',
            sortable: false
          }
        ]
      },
      subHeaders() {
        return [
          {
            text: this.$t('general.noInspection'),
            align: 'center',
            value: 'consecutive_number'
          },
          {
            text: this.$t('general.inspectionDate'),
            align: 'center',
            value: 'created_at'
          },
          {
            text: this.$t('general.checklistName'),
            align: 'center',
            value: 'name'
          },
          {
            text: this.$t('general.duration'),
            align: 'center',
            value: 'duration'
          },
          {
            text: 'Inspector',
            align: 'center',
            value: 'user:name'
          },
          {
            text: this.$t('general.operat'),
            align: 'center',
            value: 'current_operator'
          },
          {
            text: this.$t('general.inspectionYard'),
            align: 'center',
            value: 'site:name'
          },
          {
            text: this.$t('general.actions'),
            align: 'center',
            value: 'actions',
            sortable: false
          }
        ]
      },
      rules () {
        return this.$validationRules()
      },
      sitesList() {
        return [
          { text: this.$t('units.OWN'), name: 'OWN' },
          { text: this.$t('units.EXTERNAL'), name: 'EXTERNAL' }
        ]
      },
    },
    created () {
      this.$store.dispatch('sites/get', { event: { context: this, item: { perPage: -1, page: 1 } } })
      this.$store.dispatch('unitTypes/getAll', { event: { context: this } })
      this.get()
    },
    methods:{
      returnStartDate() {
        const now = new Date()
        return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().substr(0, 10)
      },
      returnEndDate() {
        const now = new Date()
        return new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().substr(0, 10)
      },
      resetFilter() {
        this.filter = {
          plateNum: '',
          numberEco: '',
          unit_type_id: null,
          property: '',
          dateRange: true,
          date_start: this.returnStartDate(),
          date_end: this.returnEndDate()
        }

        this.optionsDataTable.page = 1
        
        this.get()
      },
      filterData(){
        if(!this.$refs.form.validate()) return this.showNotification(this.$t('general.errorFilterMessage'), 'warn', -1)

        this.optionsDataTable.page = 1
        
        this.get()
      },
      viewItem (id) {
        this.$router.push('/inspectionUnitTypes/view/' + id)
      },
      download (item) {
        this.loadingButton = true
        this.$store.dispatch('reports/getInspectionUnitTypeDoc', {
          event: {
            context: this,
            params: {
            date_start: this.filter.date_start === null ? undefined : this.filter.date_start,
            date_end: this.filter.date_end === null ? undefined : this.filter.date_end,
            unit_id: item.id
            }
          }
        })
      },
      get () {
        if(this.loadingTableInspection) return
        
        this.loadingTableInspection = true

        this.filter.find = `${this.filter.plateNum} ${this.filter.numberEco}`.trim();
        this.$store.dispatch('reports/getInspectionUnitType', {
          event: {
            context: this,
            params: {
              date_end: this.filter.date_end === null ? undefined : this.filter.date_end,
              date_start: this.filter.date_start === null ? undefined : this.filter.date_start,
              page: this.optionsDataTable.page,
              perPage: this.optionsDataTable.itemsPerPage,
              find: this.filter.find || undefined,
              unit_type_id: this.filter.unit_type_id || undefined,
              owner: this.filter.property || undefined,
              type: 'json',
              sortKey: (this.optionsDataTable.sortBy && this.optionsDataTable.sortBy.length > 0) ? this.optionsDataTable.sortBy[0] : 'count_damange_hard',
              ord: this.optionsDataTable.sortDesc && this.optionsDataTable.sortDesc[0] ? 'ASC' : 'DESC',
            }
          }
        })
      },
      downloadGeneral () {
        if(!this.$refs.form.validate()) return this.showNotification(this.$t('general.errorFilterMessage'), 'warn', -1)
        
        this.loadingButtonGeneral = true

        this.filter.find = `${this.filter.plateNum} ${this.filter.numberEco}`.trim();
        
        this.$store.dispatch('reports/getInspectionUnitTypeIndexDoc', {
          event: {
            context: this,
            params: {
              date_end: this.filter.date_end === null ? undefined : this.filter.date_end,
              date_start: this.filter.date_start === null ? undefined : this.filter.date_start,
              page: this.optionsDataTable.page,
              perPage: this.optionsDataTable.itemsPerPage,
              find: this.filter.find || undefined,
              unit_type_id: this.filter.unit_type_id || undefined,
              owner: this.filter.property || undefined,
              type: 'download',
              sortKey: (this.optionsDataTable.sortBy && this.optionsDataTable.sortBy.length > 0) ? this.optionsDataTable.sortBy[0] : 'count_damange_hard',
              ord: this.optionsDataTable.sortDesc && this.optionsDataTable.sortDesc[0] ? 'ASC' : 'DESC',
            }
          }
        })
      },
      translateProperty(value) {
      const propertyMap = {
        'OWN': this.$t('units.OWN'),
        'EXTERNAL': this.$t('units.EXTERNAL'),
      };
      return propertyMap[value] || 'N/A';
      },
      handleDateStartSelection(date) {
      this.filter.date_start = date;
      this.updateDateEnd();
      this.menu = false;
      },

      allowedStartDates() {
        return true;
      },

      allowedEndDates(date) {
        if (!this.filter.date_start) return true;

        const startDate = new Date(this.filter.date_start);
        const endDateLimit = new Date(startDate);
        endDateLimit.setDate(startDate.getDate() + 29);

        return new Date(date) >= startDate && new Date(date) <= endDateLimit;
      },

      updateDateEnd() {
        if (this.filter.date_start) {
          const startDate = new Date(this.filter.date_start);
          const endDateLimit = new Date(startDate);
          endDateLimit.setDate(startDate.getDate() + 29);

          this.filter.date_end = endDateLimit.toISOString().substr(0, 10);
        }
      },

      getDayStyle(date) {
        if (
          (this.filter.date_start && this.allowedEndDates(date)) ||
          (!this.filter.date_start && this.allowedStartDates(date))
        ) {
          return null;
        }
        return { backgroundColor: 'rgba(0, 0, 0, 0.1)', color: 'gray' };
      },
    }
  }
</script>